import React from 'react';
import AverageStats from '../components/AverageStats';
import { Fade } from 'react-reveal';

const Strategy = () => (
  <div className="bg-primary">
    <div className="pt-2">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl leading-12 font-extrabold text-white sm:text-4xl lg:text-6xl">
            STRATEGY + SKILL
          </h2>
          <p className="mt-4 text-xl leading-7 text-white">
            We're putting the personal touch back into consulting. We solve marketing problems by
            creating strategies from a top-down approach. We don't lecture from afar; we get in the
            trenches with you.
          </p>
          <h2 className="mt-6 md:mt-16 md:mb-16 text-4xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10 lg:text-7xl">
            =
          </h2>
        </div>
      </div>
    </div>

    <div className="mt-8 bg-white pb-5 sm:mt-12 lg:pb-10">
      <div className="relative">
        <div className="absolute inset-0 h-1/2 bg-primary"></div>
        <div className="relative max-w-screen-xl mx-auto">
          <div className="bg-white px-10 py-12 max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
            <div className="text-center mx-auto">
              <h3 className="text-4xl leading-10 font-extrabold text-gray-700">
                RESULTS Based On Your Goals
              </h3>
              <p className="mt-6 text-base leading-6 text-gray-500">
                We work to provide real value, real insights, and real results that lead to growth.
              </p>
              <div className="mt-8">
                <div className="flex items-center">
                  <h4 className="flex-shrink-0 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-blue-600">
                    Average Statistics from our Clients
                  </h4>
                  <div className="flex-1 border-t-2 border-gray-200"></div>
                </div>
                <Fade In duration={2500}>
                  <AverageStats />
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Strategy;
